import * as rootSelectors from '../../selectors/root';
import { createSelector } from 'reselect';
import get from 'lodash/get';

export const selectEventsSlice = state => state.events;
export const selectEventwideSlice = state => state.eventwide;
export const selectActiveMaster = createSelector(
    [selectEventsSlice],
    (eventsSlice) => {
        return get(eventsSlice, 'activeMaster', null);
    },
);
export const selectActiveMasterEvents = createSelector(
    [selectEventsSlice],
    (eventsSlice) => {
        return get(eventsSlice, 'activeMaster', []);
    },
);

export const selectActiveMasterEventsEF = createSelector(
    [selectActiveMasterEvents],
    (events) => {
        return get(events, 'data', []).map(event => {
            return {
                endTime: get(event, 'attributes.endTime.short'),
                heroImage: get(event, 'heroImage'),
                id: event.id,
                name: get(event, 'attributes.name'),
                startTime: get(event, 'attributes.startTime.short')
            }
        })
    },
);

export const selectActiveMasterEventsEFMeta = createSelector(
    [selectActiveMasterEvents],
    (activeMaster) => {
        return get(activeMaster, 'meta', {})
    },
);

export const selectActiveMasterEventsMS = createSelector(
    [selectActiveMasterEvents,         rootSelectors.selectActiveMasterEventsFirebase],
    (events, firebaseEvents) => {
        return get(events, 'data',[]).map(event => {
            return {
                endTime: get(event, 'endDate'),
                eventAppEnabled: firebaseEvents[event['id']] ? true : false,
                id: get(event, 'id'),
                name: get(event, 'name'),
                startTime: get(event, 'startDate')
            }
        })
    },
);

//USED IN MAIN EVENTS LIST
export const makeEventsList = createSelector(
    [
        selectActiveMasterEventsEF,
        selectActiveMasterEventsMS
    ],
    (efEvents, msEvents) => {

                return efEvents;

    },
);
export const getActiveEvent = createSelector(
    [rootSelectors.selectActiveEfEvent],
    (event) => {
        return event
    },
);

export const getActiveEventPoolFeatures = createSelector(
    [getActiveEvent],
    (event) => {
        const poolFeatures = get(event, 'extraAttributes.PoolFeatures')
        return poolFeatures
    },
);

export const getIsBetaEnabled = createSelector(
    [getActiveEventPoolFeatures],
    (features) => {
        const filtered =  features.filter(feature => feature.name === 'Beta Features')
        return filtered && filtered.length ? filtered[0].isEnabled : false
    },
);

export const getActiveEventHero = createSelector(
    [getActiveEvent],
    (event) => {
        return get(event, 'heroImage.null')
    },
);

export const selectActiveModules = createSelector(
    state => state.activeModules,
    activeModules => activeModules,
);

export const selectInviteeCountForEvent = createSelector(
    [selectEventwideSlice],
    eventwide => {
        return eventwide.eventInviteesCount
    },
);


export const getActiveEventName = createSelector(
    [getActiveEvent],
    (event) => {
        return get(event, 'attributes.name')
    },
);
export const makePoolId = createSelector(
    [rootSelectors.selectActiveEventId, selectActiveMasterEvents],
    (event_id, masterEvents) => {
        const me =  masterEvents.data.filter(event => {
            return event.id === event_id;
        })[0]
            return get(me, 'relationships.pool.id')
    },
);
